<template>
    <div class="editor">
        <div class="menu-bar" v-if="editor">
            <div>
                <button @click="editor.chain().focus().toggleBold().run()"
                    :disabled="!editor.can().chain().focus().toggleBold().run()"
                    :class="{ 'is-active': editor.isActive('bold') }">
                    <i class="fa fa-bold"></i>
                </button>
                <button @click="editor.chain().focus().toggleItalic().run()"
                    :disabled="!editor.can().chain().focus().toggleItalic().run()"
                    :class="{ 'is-active': editor.isActive('italic') }">
                    <i class="fa fa-italic"></i>
                </button>
                <button @click="editor.chain().focus().toggleStrike().run()"
                    :disabled="!editor.can().chain().focus().toggleStrike().run()"
                    :class="{ 'is-active': editor.isActive('strike') }">
                    <i class="fa fa-strikethrough"></i>
                </button>
            </div>
            <div>
                <button @click="editor.chain().focus().toggleHeading({ level: 1 }).run()"
                    :class="{ 'is-active': editor.isActive('heading', { level: 1 }) }">
                    h1
                </button>
                <button @click="editor.chain().focus().toggleHeading({ level: 2 }).run()"
                    :class="{ 'is-active': editor.isActive('heading', { level: 2 }) }">
                    h2
                </button>
                <button @click="editor.chain().focus().toggleHeading({ level: 3 }).run()"
                    :class="{ 'is-active': editor.isActive('heading', { level: 3 }) }">
                    h3
                </button>
            </div>
            <div>
                <button @click="editor.chain().focus().toggleCode().run()"
                    :disabled="!editor.can().chain().focus().toggleCode().run()"
                    :class="{ 'is-active': editor.isActive('code') }">
                    <i class="fa fa-code"></i>
                </button>
                <!-- <div @click="editor.chain().focus().clearNodes().run()">
      clear nodes
    </div> -->
                <button @click="editor.chain().focus().setParagraph().run()"
                    :class="{ 'is-active': editor.isActive('paragraph') }">
                    <i class="fa fa-paragraph"></i>
                </button>
            </div>

            <div>
                <button @click="editor.chain().focus().toggleBulletList().run()"
                    :class="{ 'is-active': editor.isActive('bulletList') }">
                    <i class="fa fa-list-ul"></i>
                </button>
                <button @click="editor.chain().focus().toggleOrderedList().run()"
                    :class="{ 'is-active': editor.isActive('orderedList') }">

                    <i class="fa fa-list-ol"></i>
                </button>
            </div>
            <div>
                <button @click="editor.chain().focus().undo().run()" :disabled="!editor.can().chain().focus().undo().run()">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" style="height: 14px;width: 14px;">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3" />
                    </svg>

                </button>
                <button @click="editor.chain().focus().redo().run()" :disabled="!editor.can().chain().focus().redo().run()">

                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" style="height: 14px;width: 14px;">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="m15 15 6-6m0 0-6-6m6 6H9a6 6 0 0 0 0 12h3" />
                    </svg>
                </button>
            </div>



        </div>
        <div class="editor-input">
            <editor-content :editor="editor" />
        </div>
    </div>
</template>
  
<script>
import { Editor, EditorContent } from '@tiptap/vue-2'
import StarterKit from '@tiptap/starter-kit'

export default {
    components: {
        EditorContent,
    },

    props: {
        value: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            editor: null,
        }
    },

    watch: {
        value(value) {
            // HTML
            const isSame = this.editor.getHTML() === value

            // JSON
            // const isSame = JSON.stringify(this.editor.getJSON()) === JSON.stringify(value)

            if (isSame) {
                return
            }

            this.editor.commands.setContent(value, false)
        },
    },

    mounted() {
        this.editor = new Editor({
            content: this.value,
            extensions: [
                StarterKit,
            ],
            onUpdate: () => {
                // HTML
                this.$emit('input', this.editor.getHTML())

                // JSON
                // this.$emit('input', this.editor.getJSON())
            },
        })
    },

    beforeDestroy() {
        this.editor.destroy()
    },
}
</script>

<style >
.editor {
    position: relative;
    border: 1px solid rgb(231 229 228);
    padding: 0px;
}

.menu-bar {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    border: 1px solid rgb(231 229 228);
}

.menu-bar>div {
    display: flex;
    justify-content: space-around;
    flex-direction: row;
    background-color: none;
    border-right: 1px solid rgb(231 229 228);
}

.menu-bar>div button {
    background: transparent !important;
    background-color: transparent !important;
    padding: 0.5rem;
    color: black;
}

.editor-input {
    margin-top: 39px;
    overflow-y: scroll;
    padding: 4px;
}

.tiptap-editor {
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 10px;
}

.editor-input .tiptap {
    min-height: 300px;
}

.editor-input .tiptap:focus-visible {
    outline-color: transparent !important;
}

.editor-input p {
    margin-bottom: 0px;
}

</style>